import { Building2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { ALL_BRANCHES } from "../branch/branchScope";
import { applyBranchSelection, useBranchScope } from "../branch/useBranchScope";

/**
 * Bộ chọn chi nhánh ở thanh trên. Ẩn ở phòng khám chỉ có một chi nhánh để chọn (Lite): không có gì
 * để chuyển thì "🏥 Chi nhánh chính" chỉ là tiếng ồn.
 *
 * <p>Ba điều của #19869:
 *
 * <ul>
 *   <li>Có mục <b>"Tất cả chi nhánh"</b> — chọn là XOÁ `addy.branchId`, nên request không còn mang
 *       `X-Addy-Branch-Id` và server tính theo quyền của người dùng (#19842). Đó là đường về số
 *       toàn phòng khám mà trước đây chỉ xoá localStorage bằng tay mới có.
 *   <li>Key trống KHÔNG còn hiện `branches[0]` như đang chọn. Trống là một phạm vi thật và nó có
 *       tên; hiện tên một chi nhánh trong khi báo cáo cộng cả phòng khám là màn hình tự nói sai.
 *   <li>Chỉ mời những chi nhánh người dùng được phép (claim `branches`), vì `/v1/branches` trả cả
 *       những chi nhánh mà chọn vào sẽ bị 403 `branch_forbidden`.
 * </ul>
 *
 * <p>Nhãn ở nút bấm do chính chúng ta vẽ chứ không dùng `SelectValue`: khi key đang giữ một chi
 * nhánh không còn trong danh sách, `SelectValue` không có gì để in và nút trở thành trống — trong
 * khi header vẫn đang được gửi. Trạng thái đó phải đọc được, không được im lặng.
 */
export function BranchSwitcher() {
  const scope = useBranchScope();

  if (!scope.showSwitcher) {
    return null;
  }

  return (
    <Select value={scope.value} onValueChange={applyBranchSelection}>
      <SelectTrigger
        className="w-full max-w-[200px]"
        title="Phạm vi chi nhánh"
        aria-label="Phạm vi chi nhánh"
      >
        <div className="flex items-center gap-2 truncate">
          <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="truncate">
            {scope.pinnedId ? scope.label : scope.allOptionLabel}
          </span>
        </div>
      </SelectTrigger>
      <SelectContent>
        {/* Mục đầu tiên: bỏ ghim. Đặt trên cùng vì đó là trạng thái mặc định của một phòng khám
            chưa chọn gì, và là chỗ người ta tìm khi muốn xem lại số của cả phòng khám. */}
        <SelectItem value={ALL_BRANCHES}>{scope.allOptionLabel}</SelectItem>
        {scope.options.map((b) => (
          <SelectItem key={b.id} value={b.id}>
            {b.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
